module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('paper', {
    staticClass: "mu-drawer",
    class: {
      'open': _vm.open, 'right': _vm.right
    },
    style: (_vm.drawerStyle),
    attrs: {
      "zDepth": _vm.zDepth
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb53f29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/drawer/drawer.vue
// module id = 445
// module chunks = 1